type Props<T extends string> = {
  value: T;
  onChange: (v: T) => void;
  options: { value: T; label: string; count?: number }[];
};

export function PillTabs<T extends string>({ value, onChange, options }: Props<T>) {
  return (
    <div className="grid w-full grid-cols-2 gap-1 rounded-[10px] bg-surface-alt p-1 sm:inline-flex sm:w-auto sm:flex-wrap sm:gap-0.5">
      {options.map((opt) => {
        const active = opt.value === value;
        return (
          <button
            key={opt.value}
            type="button"
            onClick={() => onChange(opt.value)}
            className={`min-h-10 min-w-0 rounded-md px-2.5 py-1.5 text-center text-[13px] font-medium leading-tight transition-colors sm:min-h-0 sm:flex-none sm:px-3.5 ${
              active
                ? "bg-surface text-text shadow-sm"
                : "text-text-muted hover:text-text"
            }`}
          >
            <span className="break-words">{opt.label}</span>
            {opt.count != null && (
              <span className="ml-1.5 text-text-soft">{opt.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
}
